import React, { useState, useEffect } from "react";
import { IntlProvider } from "react-intl";
import { changeQueryParameter, GetQueryParameter } from "../../Utilities/Url";
// import { GetContext } from "../../Utilities/TeamsContextHandler";
import { useHistory } from "react-router-dom";

const de = require("../../Languages/de.json");
const en = require("../../Languages/en.json");
const fr = require("../../Languages/fr.json");

interface ILocalizationProviderProps {
  children: React.ReactNode;
}

const LocalizationProvider: React.FC<ILocalizationProviderProps> = ({
  children,
}) => {
  const [locale, setLocale] = useState<string>(GetQueryParameter("locale") || "en");
  const history = useHistory();

  useEffect(() => {
    const urlLocale = GetQueryParameter("locale");
    if (urlLocale) {
      setLocale(urlLocale);
    } else {
      const newSearch = changeQueryParameter("locale", "en");
      history.replace({
        pathname: history.location.pathname,
        search: newSearch,
      });
    }
  }, []);

  useEffect(() => {
    const urlLocale = GetQueryParameter("locale");
    if (urlLocale && urlLocale !== locale) {
      setLocale(urlLocale);
    }
  }, [history.location.search]);

  useEffect(() => {
    const newSearch = changeQueryParameter("locale", locale);
    if (history.location.search !== `?${newSearch}`) {
      history.replace({
        pathname: history.location.pathname,
        search: newSearch,
      });
    }
  }, [locale]);

  const getMessages = (locale: string) => {
    switch (locale) {
      case "de":
        return de;
      case "fr":
        return fr;
      default:
        return en;
    }
  };

  const getCurrentLocale = () => {
    return locale;
  };

  const currentLocale = getCurrentLocale();
  const messages = getMessages(currentLocale);

  return (
    <IntlProvider locale={currentLocale} messages={messages}>
      {children}
    </IntlProvider>
  );
};

export default LocalizationProvider;
